// This is the default sorting column for the evaluator completion report.
export const EVALUATOR_NAME_SORT_FIELD: string = 'displayName';
